import {
    HAS_SEARCH_RESULTS,
    SET_LOCAL_TOWNS,
    SET_SEARCH_RESULTS_LOADING,
    RESET_SEARCH_PAGE_STATE,
} from './types';

export const hasSearchResults = (payload = false) => {
    return {
        type: HAS_SEARCH_RESULTS,
        payload,
    };
};

export const setLocalTowns = (payload) => {
    return {
        type: SET_LOCAL_TOWNS,
        payload,
    };
};

export const setSearchResultsLoading = (payload) => {
    return {
        type: SET_SEARCH_RESULTS_LOADING,
        payload,
    };
};

export const resetSearchPageGlobalState = () => {
    return {
        type: RESET_SEARCH_PAGE_STATE,
    };
};
